<template>
  <div class="px-5 py-5">
    <template v-if="loading">
      <v-skeleton-loader
        :data-qa="dataQa + '-loading'"
        :height="44"
        type="card"/>
      <v-skeleton-loader
        class="mt-5"
        :data-qa="dataQa + '-loading-2'"
        :height="44"
        type="card"/>
      <v-skeleton-loader
        class="mt-5"
        :data-qa="dataQa + '-loading-3'"
        :height="44"
        type="card"/>
      <v-skeleton-loader
        class="mt-5"
        :data-qa="dataQa + '-loading-4'"
        :height="44"
        type="card"/>
    </template>
    <template v-else-if="item">
      <KeyValue
        :caption="$t('Purchasing.Status')"
        class="mr-6"
        :data-qa="dataQa + '-status'">
        <StatusChip
          :data-qa="dataQa + '-status-content'"
          key-name="id"
          :name="$t(`groupOfAccreditation.status.${item.status}`)"
          :status="item.status"
          text-color="var(--color-black)"
          value-name="title"/>
      </KeyValue>
      <KeyValue
        v-if="item.isTest"
        :caption="$t('groupOfAccreditation.testGroup')"
        class="mt-5"
        :data-qa="dataQa + '-isTest'"
        :value="$t('Tenders.Yes')"/>
      <KeyValue
        v-if="item.description"
        :caption="$t('Tenders.AdditionalDescription')"
        class="mt-5"
        :data-qa="dataQa + '-description'">
        <TooltipedTextLineCount
          :line-count="2"
          :line-height="1.25"
          :value="item.description"/>
      </KeyValue>
      <KeyValue
        v-if="growthBook.show_isDocumentsSigningRequired"
        :caption="$t('groupOfAccreditation.requireDocumentSigning')"
        class="mt-5"
        :data-qa="dataQa + '-isDocumentsSigningRequired'"
        :value="item.isDocumentsSigningRequired ? $t('Tenders.Yes') : $t('Tenders.No')"/>
      <KeyDate
        v-if="item.datePublish"
        :caption="$t('Tenders.PublicationDate')"
        class="mt-5"
        :data-qa="dataQa + '-datePublish'"
        :value="item.datePublish"/>
      <KeyDate
        v-if="item.created && item.created.date"
        :caption="$t('Tenders.DateOfCreation')"
        class="mt-5"
        :data-qa="dataQa + '-creationDate'"
        :value="item.created ? item.created.date : null"/>
      <KeyDate
        v-if="item.modified && item.modified.date"
        :caption="$t('Tenders.DateOfModification')"
        class="mt-5"
        :data-qa="dataQa + '-modificationDate'"
        :value="item.modified ? item.modified.date : null"/>
    </template>
  </div>
</template>
<script>
import KeyDate from 'components/common/KeyDate.vue'
import KeyValue from 'components/common/KeyValue.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import TooltipedTextLineCount from 'components/common/blocks/tooltiped text/TooltipedTextLineCount.vue'

export default {
  name: 'GroupOfAccreditationInfo',
  components: {
    KeyDate,
    KeyValue,
    StatusChip,
    TooltipedTextLineCount,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dataQa: {
      type: String,
      default: 'group-of-accreditation-info'
    },
  },
}
</script>
